/**
 * Mirror the rounding used by the Area dialog's getDimension so estimate/description
 * dimension values match it. Inch surfaces divide by 1728 and would otherwise render
 * long decimals. Whole numbers render without decimals; everything else is fixed to 2dp.
 *
 * Always returns a string (it is only ever embedded in label text). `val.toFixed(0)` is
 * the whole-number form: if the 2dp value differs from it, the number has a meaningful
 * fractional part and we keep 2 decimals; otherwise we drop the decimals entirely.
 */
export function roundDimensionValue(val: number): string {
  if (Number.parseFloat(val.toFixed(2)) !== Number.parseFloat(val.toFixed(0))) {
    return val.toFixed(2)
  } else {
    return val.toFixed(0)
  }
}
